import axios from "axios";
import {
  fetchDegreesStart,
  fetchDegreesSuccess,
  fetchDegreesFailure,
  addDegreeStart,
  addDegreeSuccess,
  addDegreeFailure,
  updateDegreeStart,
  updateDegreeSuccess,
  updateDegreeFailure,
  deleteDegreeStart,
  deleteDegreeSuccess,
  deleteDegreeFailure,
  fetchDegreeNamesStart,
  fetchDegreeNamesSuccess,
  fetchDegreeNamesFailure
} from "../slicer/degreeSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
// Fetch degrees
export const fetchDegrees = () => async (dispatch) => {
  dispatch(fetchDegreesStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDegreePrograms`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(fetchDegreesSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchDegreesFailure(
        error.response?.data?.message || "Failed to fetch degrees"
      )
    );
  }
};

// Add a new degree
export const addDegree = (degreeInfo) => async (dispatch) => {
  dispatch(addDegreeStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/addDegreeProgram`,
      degreeInfo,
      { headers } // Added authentication headers
    );
    dispatch(addDegreeSuccess(response.data.data));

    // **Crucially, move the success logic here:**
    alert("Degree added successfully!");
    window.location.reload(); // Or, preferably, use navigate to a different page

  } catch (error) {
    dispatch(
      addDegreeFailure(
        error.response?.data?.message || "Failed to add degree"
      )
    );
  }
};

// Update a degree
export const updateDegree = (degreeInfo, id) => async (dispatch) => {
  dispatch(updateDegreeStart());
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/updateDegreeProgram/${id}`,
      degreeInfo,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateDegreeSuccess(response.data.data));
  } catch (error) {
    dispatch(
      updateDegreeFailure(
        error.response?.data?.message || "Failed to update degree"
      )
    );
  }
};

// Delete a degree
export const deleteDegree = (id) => async (dispatch) => {
  dispatch(deleteDegreeStart());
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/deleteDegreeProgram/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(deleteDegreeSuccess(id));
  } catch (error) {
    dispatch(
      deleteDegreeFailure(
        error.response?.data?.message || "Failed to delete degree"
      )
    );
  }
};

export const fetchDegreeNames = () => async (dispatch) => {
  dispatch(fetchDegreeNamesStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDegreeNames`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(fetchDegreeNamesSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchDegreeNamesFailure(
        error.response?.data?.message || "Failed to fetch degree names"
      )
    );
  }
};